import React, { useState, useMemo, useContext, useEffect } from "react";
import {

// /home/skygifted/Documents/KSSLB-2025/ksslb-frontend-portal/src/components/Section/Contents/FormProcess/Forms/loan/LoanCalculator.js
    Box,
    Grid,
    TextField,
    Button,
    Typography,
    Stack,
    Divider,
} from "@mui/material";
import CreditSearch from "./CreditSearch";
import InPrincipleOfferThirdParty from "../../ProcessContents/SectionContent/offersAll/InPrincipleOfferThirdParty";
import { ContextData } from "../../../../../../context/Context";
import { Getrequest, Postrequest } from "../../../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import InPrincipleOfferStudentLoan from "../../ProcessContents/SectionContent/offersAll/InPrincipleOfferStudentLoan";

function formatNumber(value) {
    if (value === "" || value == null) return "";
    // value is raw digits string (no decimals). Convert to number then format.
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    return new Intl.NumberFormat().format(num);
}

function parseNumber(formattedOrRaw) {
    if (formattedOrRaw == null || formattedOrRaw === "") return 0;
    return Number(String(formattedOrRaw).replace(/[^\d]/g, "")) || 0;
}

export default function LoanCalculator({program_type,from, email,guarantor, Sponsor,Student,tenor,loanAmount,user_tokens }) {

    // store raw digits for each month to avoid formatting artifacts
    const [salaries, setSalaries] = useState(["", "", "", "", "", ""]);
    const [offerName, setOfferName] = useState("");
    const [PaySlip,setPaySlip] = useState("")
    const [showLoanCalculator,setShowLoanCalculator] = useState(false)
    const [reload,setreload] = useState(true)
    const {UserTokens,accesstoken} = useContext(ContextData)
    const [SubmittedOffer,setSubmittedOffer]  = useState([])
    const handleSalaryChange = (index) => (e) => {
        // accept only digits
        const digits = String(e.target.value).replace(/\D/g, "");
        setSalaries((prev) => {
            const next = [...prev];
            next[index] = digits;
            return next;
        });

         

    };

    const handleOfferNameChange = (e) => setOfferName(e.target.value);
    const handlePaySlipChange = (e) => setPaySlip(String(e.target.value).replace(/\D/g, ""));
    const tenorMonths = (Number(tenor) * 12)


    useEffect(()=>{


        (async()=>{


                const response = await Getrequest(`/auth/get_inpriciple_offer/${user_tokens}`,accesstoken)

                      setSubmittedOffer([response])   

                    
         
        })()  


         
    },[reload])



    const totals = useMemo(() => {
        
        let checkEmptyInput = salaries.some(month => month === "") 
        const  months = salaries.map(parseNumber);
        const  average = months.reduce((a, b) => a + b, 0) / months.filter((m) => m > 0).length || 0
        const  sum = months.reduce((a, b) => a + b, 0)
        const  minAmount = Math.min(Number(average), Number(PaySlip));
        const  LabourLaw =  (minAmount / 3)
        const  Total_before_deduction_of_intrest = (LabourLaw * tenorMonths)
        const  intrestAmount = 8 / 100 * Total_before_deduction_of_intrest 
        const  Total_after_deduction_of_intrest  = Total_before_deduction_of_intrest - intrestAmount
        const  OfferAmount = Math.min(Math.round(loanAmount),Total_after_deduction_of_intrest) 
       
           if(checkEmptyInput) {

              checkEmptyInput = true

           }else{
               if(OfferAmount === 0){

                 checkEmptyInput = true

               }else{

                   checkEmptyInput = false

               }
           }

        return {
            months,
            average,
            sum,
            minAmount,
            LabourLaw,
            Total_before_deduction_of_intrest,
            intrestAmount,
            Total_after_deduction_of_intrest,
            OfferAmount,
            checkEmptyInput
        };
    }, [salaries,PaySlip]);



 const dataThirdParty = {

               Sponsor: Sponsor,
               Student: Student,
               Amount_Requested: loanAmount,
               Amount_Requested_Tenor: tenor,
               Amount_Offered: formatNumber(String(totals.OfferAmount)),
               Amount_Offered_Tenor: tenor,
               Credit_Report: showLoanCalculator === "ok" ? "attached" : "not attach" ,
               Credit_Status: showLoanCalculator,
               offer_status : showLoanCalculator,
               user_token : user_tokens,
               bank_reviewer_token : UserTokens,
               program_type,
               email,
               guarantor: ""
  }
     
  
    const  dataStudent =  useMemo(() => {



         let amount_offered
         let medicalAmount = 2000000
         let nonMedicalAmount = 1000000

         if(program_type === "non-medical-applicant") {
            
              if( loanAmount > nonMedicalAmount) {

                  amount_offered = nonMedicalAmount

              }else{

                  amount_offered = loanAmount
              }

          }

         if(program_type === "medical-applicant") {
            
              if(loanAmount > medicalAmount) {

                  amount_offered = medicalAmount

              }else{

                  amount_offered = loanAmount

              }

          }
     

          
      return {

               guarantor: guarantor,
               Student: Student,
               Amount_Requested: loanAmount,
               Amount_Requested_Tenor: tenor,
               Amount_Offered: formatNumber(String(amount_offered)),
               Amount_Offered_Tenor: tenor,
               Credit_Report: showLoanCalculator === "ok" ? "attached" : "not attach" ,
               Credit_Status: showLoanCalculator,
               offer_status : showLoanCalculator,
               user_token : user_tokens,
               bank_reviewer_token : UserTokens,
               email,
               program_type,
  }




  },[from,showLoanCalculator])




    const handleSend = () => {
       

      
          

        const checkEmpty = totals.months.every(month => month === "")
         let data

          if(from === "thirdparty") {

              if(checkEmpty) {

              return alert("some inputs are empty")

         }else{

              data = dataThirdParty
         }
            

          }

          if(from === "studentloan") {
             

                data = dataStudent
          }
       



        (
            async()=>{

                   const response = await Postrequest("/auth/set_inpriciple_offer",data,accesstoken)

                   if(response.status){
                       toast.success(response.textStatus)
                        setreload(!reload)
                   }
            }
        )()






    };

    return (
        <Box sx={{ p: 2 }}>

              <CreditSearch email={email} showLoanCalculator={showLoanCalculator} setShowLoanCalculator={setShowLoanCalculator} user_tokens={user_tokens} />

            
             {
                showLoanCalculator === 'ok' && 

            <div>

               {
                from === "thirdparty"  && 

                <>
           <Typography variant="h6" gutterBottom>
                Loan Calculator
            </Typography>

            <Box sx={{ mb: 2 }}>

                <Typography variant="subtitle2" gutterBottom>
                    Enter last six months' salaries (numbers only)
                </Typography>

                <Grid container spacing={2}>
                    {Array.from({ length: 6 }).map((_, idx) => (
                        <Grid item xs={12} sm={6} md={4} key={idx}>
                            <TextField
                                label={`Month ${idx + 1}`}
                                value={formatNumber(salaries[idx])}
                                onChange={handleSalaryChange(idx)}
                                fullWidth
                                inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ mb: 2 }}>
              

                <Stack spacing={2}>
                    <TextField
                        label="Salary From Payslip"
                        value={formatNumber(PaySlip)}
                        onChange={handlePaySlipChange}
                        fullWidth
                         inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                }}
                    />

            

                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                      
                       Offer Amount  <Typography variant="h6">{formatNumber(String(totals.OfferAmount))}</Typography>
                     
                    </Box>
                </Stack>
            </Box>


           
            <Divider sx={{ my: 2 }} />

              {
                !totals.checkEmptyInput  &&
             <InPrincipleOfferThirdParty from="loanEv" data={dataThirdParty}  />
              }

             {/*  {
                <InPrincipleOfferStudentLoan
                  data={dataStudent}
                  from="loanEv"
                />
              } */}

            <Box sx={{ textAlign: "right" }}>
                {
                    SubmittedOffer.length > 0 ? <>
                    
                        {
                            SubmittedOffer[0].Credit_Status === "ok" ?

                                <Button
                    variant="contained"
                    color="primary"
                    disabled={true}
                >
                  successfully offered
                </Button>

                :

                 <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSend}
                    disabled={totals.checkEmptyInput}
                >
                    Set Offer
                </Button>

                        }
                     </>

               
                   :

                 <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSend}
                    disabled={totals.checkEmptyInput}
                  >
                    Set Offer
                </Button>
            
                  

                    
                }
            </Box>
                
                
                
                </>
               }


               {

                from === "studentloan"  && 

                <>
        
            <Divider sx={{ my: 2 }} />

            
           
            <Divider sx={{ my: 2 }} />

          

              {
                <InPrincipleOfferStudentLoan
                  data={dataStudent}
                  from="loanEv"
                  user_tokens={user_tokens}
                  program_type={program_type}
                />
              }


            <Box sx={{ textAlign: "right" }}>
              
                {
                    SubmittedOffer.length > 0 ? <>
                    
                        {
                    
                    SubmittedOffer[0].Credit_Status === "ok" ?

                  <Button
                    variant="contained"
                    color="primary"
                    disabled={true}
                  >
                  successfully offered
                  </Button>

                  :

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSend}
                    disabled={ showLoanCalculator === 'ok' ? false : true }
                  >
                    Set Offer
                  </Button>

                        }
                     </>

               
                   :

                 <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSend}
                    disabled={ showLoanCalculator === 'ok' ? false : true }
                  >
                    Set Offer
                  </Button>
            
                  

                    
                }
            </Box>
                
                
                
                </>
               }




            </div>
             }

          


        </Box>
    );
}